import { Address } from "@ton/core";
export const isValidAddress = (address) => {
    try {
        Address.parse(address);
        return true;
    }
    catch {
        return false;
    }
};
//# sourceMappingURL=isValidAddress.js.map